import { sendPost } from '../http.js'
const commons = (url, params, fn) => {
    return sendPost(url, params, 'post')
    .then((res) => {
        fn(res)
        //console.log('成功')
    }).catch((err) => {
        throw Error(err)
        fn(err)
        //console.log('失败')
    })
}
const api = {
	'orderInfo': '/user/order/info', // 订单列表
	'sureRefundAPI': '/wechat/video/refund_agree', // 同意退款
	'rejectRefundAPI': '/wechat/video/refund_refuse', // 拒绝退款
	'getRejectReasonListAPI': '/wechat/video/refund_rejectreason', // 获取退款原因下拉选择
	'setStockNumAPI': '/wechat/video/update_stock_num', // 修改小店课程库存
}

export default {
	getOrderInfo(params, fn) {
		commons(api.orderInfo, params, fn)
	},
    sureRefundAPI(params) {
        return sendPost(api.sureRefundAPI, params)
    },
    rejectRefundAPI(params) {
        return sendPost(api.rejectRefundAPI, params)
    },
    getRejectReasonListAPI(params) {
        return sendPost(api.getRejectReasonListAPI, params)
    },
    setStockNumAPI(params) {
        return sendPost(api.setStockNumAPI, params)
    },
}